import { Section, SectionTitle, CaseCard } from './shared';

export function EcosystemContent() {
  const ecosystemCases = [
    {
      icon: '🍎',
      title: '苹果生态打通',
      description: '配置 Skills 打通苹果生态,实现 iPhone、iPad、Mac 之间的无缝协作',
      tags: ['Apple', 'iOS', 'macOS', '生态集成'],
      difficulty: 'advanced' as const,
      link: 'https://curl.qcloud.com/HT88w762',
    },
  ];

  return (
    <div className="space-y-8">
      <Section>
        <SectionTitle>生态集成案例</SectionTitle>
        <p className="text-slate-400 mb-6">
          利用 OpenClaw 打通不同平台和设备,实现跨平台的无缝协作和数据同步。
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ecosystemCases.map((caseItem, index) => (
            <CaseCard key={index} {...caseItem} />
          ))}
        </div>
      </Section>

      <Section>
        <div className="bg-cyan-500/10 border border-cyan-500/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-cyan-400 mb-3">💡 集成能力</h3>
          <ul className="space-y-2 text-slate-300">
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>跨设备文件同步和管理</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>统一的通知和提醒系统</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>智能快捷指令集成</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>多平台数据互通</span>
            </li>
          </ul>
        </div>
      </Section>
    </div>
  );
}